import { useEffect, useState } from 'react';
import { fetchAlertsOrThrow } from '../../../api/fetchAlerts';

export interface VehicleAlert {
    vehicleId?: string;
    [key: string]: unknown;
}

const ALERT_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;
const PAGE_SIZE = 1000;
const MAX_PAGES = 10;

export const fetchRecentAlerts = async (assetIds: string[]): Promise<VehicleAlert[]> => {
    const now = new Date();
    const body = {
        pageSize: PAGE_SIZE,
        assetIds,
        tagIds: [],
        lampFilter: [],
        startAt: new Date(now.getTime() - ALERT_WINDOW_MS).toISOString(),
        endAt: now.toISOString(),
        search: '',
        zone: 'UTC-3',
    };
    const alerts: VehicleAlert[] = [];
    for (let page = 0; page < MAX_PAGES; page++) {
        const result: VehicleAlert[] = await fetchAlertsOrThrow({ ...body, page });
        alerts.push(...result);
        if (result.length < PAGE_SIZE) {
            break;
        }
    }
    return alerts;
};

const useVehicleAlerts = (assetId: string | null) => {
    const [alerts, setAlerts] = useState<VehicleAlert[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setAlerts([]);
        if (!assetId) {
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);
        fetchRecentAlerts([assetId])
            .then(result => {
                if (!cancelled) {
                    setAlerts(result.filter(alert => alert?.vehicleId === assetId));
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setAlerts([]);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [assetId]);

    return { alerts, loading };
};

export default useVehicleAlerts;
